import { Component, OnInit, EventEmitter, Output } from "@angular/core";
import { Router } from "@angular/router";
declare var $: any;

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"]
})
export class NavbarComponent implements OnInit {
  constructor(
    private router: Router
  ) {}

  ngOnInit() {}
  logout() {
    this.router.navigate(["/"]);
  }
}
